//
import { normalize } from 'normalizr';

import { simplApi } from '../../api/simplApi';
import { note } from './schemas';

import { receiveStaff } from './staff';
import { addFeedback } from './feedback';
import handleApiError from '../../helpers/handleApiError';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_NOTE = 'REQUEST_NOTE';
export const RECEIVE_NOTE = 'RECEIVE_NOTE';
export const REMOVE_NOTE = 'REMOVE_NOTE';

// ------------------------------------
// Actions
// ------------------------------------
export function requestNote() {
  return {
    type: REQUEST_NOTE,
  };
}

export function receiveNote(notes) {
  return {
    type: RECEIVE_NOTE,
    payload: {
      notes,
    },
  };
}

export const fetchNote = noteId => dispatch => {
  dispatch(requestNote());

  const url =
    typeof noteId !== 'undefined' && noteId !== null
      ? `note/${noteId}`
      : 'note';

  return simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        let preparedNotes;

        if (typeof json.id === 'undefined') {
          preparedNotes = normalize(json, [note]);
        } else {
          preparedNotes = normalize(json, note);
        }

        dispatch(receiveNote(preparedNotes.entities.notes));
        dispatch(receiveStaff(preparedNotes.entities.staffs));
      }
    });
};

export function removeNote(noteId) {
  return {
    type: REMOVE_NOTE,
    payload: noteId,
  };
}

export const deleteNote = noteId => dispatch => {
  const url = `note/${noteId}`;
  const options = { method: 'delete' };

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        dispatch(removeNote(noteId));
        dispatch(addFeedback('warning', 'Notiz gelöscht'));
      }
    });
};
export const saveNote = newNote => dispatch => {
  dispatch(requestNote());
  let url = 'note/';
  const options = { method: 'post', body: newNote };
  if (typeof newNote.id !== 'undefined' && newNote.id !== null) {
    // // console.log('updating')
    url = `${url}${newNote.id}`;
    options.method = 'put';
  }
  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        const preparedNotes = normalize(json, note);
        dispatch(receiveNote(preparedNotes.entities.notes));
        dispatch(addFeedback('success', 'Notiz gespeichert'));
      }
    });
};
export const actions = {
  requestNote,
  receiveNote,
  fetchNote,
  saveNote,
  deleteNote,
  removeNote,
};
const NOTE_ACTION_HANDLERS = {
  [REQUEST_NOTE]: state => ({
    ...state,
    fetching: true,
  }),
  [REMOVE_NOTE]: (state, action) => ({
    ...state,
    notes: _.omit(state.notes, action.payload),
  }),
  [RECEIVE_NOTE]: (state, action) => {
    const stateNotes = state.notes;
    _.forOwn(action.payload.notes, (_note, id) => {
      const newNote = _note;
      if (typeof stateNotes[id] === 'object') {
        Object.assign(stateNotes[id], stateNotes[id], newNote);
      } else {
        stateNotes[id] = newNote;
      }
    });
    return {
      ...state,
      notes: stateNotes,
      fetching: false,
    };
  },
}; // ------------------------------------ // ------------------------------------ // Reducer
const initialState = { fetching: false, notes: {} };
export default function noteReducer(state = initialState, action) {
  const handler = NOTE_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/note.js